"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const translationContext_1 = require("configs/translationContext");
const datahubPageService_1 = __importDefault(require("modules/app/services/datahub/moduleList/datahubPageService"));
const pageCardInformation_1 = __importDefault(require("./pageCardInformation"));
const pageCardLiberation_1 = __importDefault(require("./pageCardLiberation"));
const DrippingBulkActionEvents_1 = require("../DrippingBulkActionEvents");
const sendExpirationHoverEvents = () => {
    (0, DrippingBulkActionEvents_1.hoverExpirationDays)();
    datahubPageService_1.default.sendExpirationDateEvent();
};
const sendLiberationHoverEvents = (type) => {
    (0, DrippingBulkActionEvents_1.hoverDrippingDayDate)(type);
    datahubPageService_1.default.sendReleaseDateEvent(type);
};
const PageCardDripping = ({ drippingConfig, drippingConfigsSize }) => {
    const { t } = (0, translationContext_1.useTranslation)();
    if (drippingConfig) {
        const { expiration, liberation } = drippingConfig;
        return ((0, jsx_runtime_1.jsxs)("div", { className: "_d-flex _gap-4 _flex-shrink-0", children: [liberation && ((0, jsx_runtime_1.jsx)(pageCardLiberation_1.default, { liberation: liberation, onHover: () => sendLiberationHoverEvents(liberation.type) })), expiration && ((0, jsx_runtime_1.jsx)(pageCardInformation_1.default, { icon: ['fal', 'calendar-xmark'], onHover: sendExpirationHoverEvents, tooltip: t('dripping_2.expired_n_days', {
                        days: expiration.durationDays,
                        amountToPluralize: expiration.durationDays
                    }), children: t('general.n_days', {
                        days: expiration.durationDays,
                        amountToPluralize: expiration.durationDays
                    }) }))] }));
    }
    if (drippingConfigsSize) {
        return ((0, jsx_runtime_1.jsx)("div", { className: "_flex-shrink-0", children: (0, jsx_runtime_1.jsx)(pageCardInformation_1.default, { icon: ['fal', 'calendar-day'], children: t('dripping_2.amount', {
                    amountToPluralize: drippingConfigsSize,
                    data: { value: drippingConfigsSize }
                }) }) }));
    }
    return null;
};
exports.default = PageCardDripping;
